const autoNgTemplateLoaderTemplate1 = require('./option-panel.html');

import angular from 'angular';

import controller from './option-panel.controller.js';

angular.module('portainer.app').component('optionPanel', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    ngModel: '<',
    explanation: '@',
    onChange: '<',
  },
});
